import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "config.js";
import Swal from "sweetalert2";

function PaymentMethod() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleManageBilling = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${API_BASE_URL}/billing/customer-portal`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success && res.data.url) {
        window.location.href = res.data.url;
      } else {
        throw new Error("Failed to load customer portal URL");
      }
    } catch (error) {
      console.error("Billing Portal Error:", error);
      Swal.fire({
        icon: "error",
        title: "Billing Portal Failed",
        text: error.response?.data?.message || "Could not open Stripe Billing Portal. Please try again later.",
        confirmButtonColor: "#014c95",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="p-4">
      <Row className="mb-4">
        <Col className="ps-3">
          <p
            className="text-muted mb-2"
            style={{ cursor: "pointer", fontWeight: "600" }}
            onClick={() => navigate("/admin/billing")}
          >
            &larr; Back to Billing
          </p>
          <h2 className="fw-bold" style={{ fontWeight: "700" }}>Manage Payment Method</h2>
        </Col>
      </Row>

      <Row className="justify-content-center mt-3">
        <Col md={8} lg={6}>
          <Card
            className="p-5 text-center shadow-sm"
            style={{
              borderRadius: "16px",
              border: "2px solid #ECECEC",
              backgroundColor: "#ffffff",
            }}
          >
            <Card.Body className="d-flex flex-column align-items-center">
              <div
                className="mb-4 d-flex align-items-center justify-content-center"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "#f0f6ff",
                  color: "#014c95",
                }}
              >
                <i className="fas fa-credit-card fa-2x"></i>
              </div>

              <h4 className="fw-bold mb-3" style={{ fontWeight: "700" }}>Stripe Secure Billing Portal</h4>
              <p className="text-muted mb-4" style={{ fontWeight: "600", fontSize: "1rem", lineHeight: "1.6" }}>
                Add or update payment methods, manage default cards, view transaction histories, and download invoices securely via our integration with Stripe.
              </p>

              <Button
                className="w-100 py-3 fw-bold text-white mb-3"
                style={{
                  backgroundColor: "#014c95",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "700",
                  fontSize: "1.1rem",
                  transition: "background-color 0.2s ease-in-out",
                }}
                onClick={handleManageBilling}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Redirecting to Stripe...
                  </>
                ) : (
                  <>
                    <i className="fas fa-external-link-alt me-2"></i> Manage Billing on Stripe
                  </>
                )}
              </Button>

              <Button
                variant="light"
                className="w-100 py-2 border-0 fw-bold"
                style={{
                  borderRadius: "8px",
                  fontWeight: "700",
                  color: "#6c757d",
                }}
                onClick={() => navigate("/admin/billing")}
              >
                Cancel
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default PaymentMethod;
